import React, { Component } from 'react'
import { EnvironmentOutlined, MailOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

import './index.scss'
export default class index extends Component {
  render() {
    return (
      <div className="footer" style={{ backgroundColor: 'white' }}>
        <div className="footer-ul ">
          <div className="footer-ul-item" style={{ paddingLeft: '0' }}>
            <div className="footer-ul-item-title">关于锐控</div>
            <div className="footer-ul-item-test">
              <Link to="/aboutus.html">公司简介</Link>
            </div>
            <div className="footer-ul-item-test">
              <Link to="/aboutus/honorary.html">荣誉资质</Link>
            </div>
            <div className="footer-ul-item-test">
              <Link to="/aboutus/ecology.html">锐控生态</Link>
            </div>
          </div>
          <div className="footer-ul-item">
            <div className="footer-ul-item-title">产品中心</div>

            <div className="footer-ul-item-test">
              <Link to="/product/hardware.html">硬件产品</Link>
            </div>
            <div className="footer-ul-item-test">
              <Link to="/product/solution.html">解决方案</Link>
            </div>
            <div className="footer-ul-item-test">
              <Link to="/aboutus/idea.html">科技创新</Link>
            </div>
          </div>
          <div className="footer-ul-item">
            <div className="footer-ul-item-title">解决方案</div>
            <div className="footer-ul-item-test">
              <Link to="/product/solution/3.html">数据可视化</Link>
            </div>
            <div className="footer-ul-item-test">
              <Link to="/product/solution/1.html">智能井盖</Link>
            </div>
            <div className="footer-ul-item-test">
              <Link to="/product/solution/4.html">机房监控</Link>
            </div>
          </div>

          <div className="footer-ul-item">
            <div className="footer-ul-item-title">联系我们</div>
            <div className="footer-ul-item-test" style={{ width: '6rem' }}>
              林经理 155 3550 0634
            </div>
            <div className="footer-ul-item-test" style={{ width: '6rem' }}>
            何经理 137 1622 9000
            </div>
            <div className="footer-ul-item-test" style={{ width: '6rem' }}>
            师经理 185 1309 9902
            </div>
          </div>
          <div className="footer-ul-item" style={{ borderRight: 'none', paddingRight: '0', width: '8rem' }}>
            <div className="footer-ul-item-title" style={{ marginBottom: '.5rem ' }}>
              <img src={require('../../image/kejilong.png')} alt="" className="footer-ul-item-title-img" />
            </div>
            <div className="footer-ul-item-test1" style={{ width: '7.2rem' }}>
              <EnvironmentOutlined style={{ fontSize: '0.55rem', color: '#2176D0', paddingTop: '0.3rem', marginRight: '.142857rem ' }} />
              <div className="footer-ul-item-test1-span">北京市大兴区黄亦路格雷众创园B座527</div>
            </div>
            <div className="footer-ul-item-test1" style={{ width: '7.2rem', marginTop: '5px' }}>
              <MailOutlined style={{ fontSize: '0.55rem', color: '#2176D0', paddingTop: '0.3rem', marginRight: '.2rem ' }} />
              <div style={{ width: '7.057143rem' }} className="footer-ul-item-test1-span1">
                {' '}
                linlijun2004@126.com
              </div>
            </div>
          </div>
          <div className="footer-ul-item">
            <img className="footer-ul-item-img" src={require('../../image/二维码.png')} alt="" />
            <div className="footer-ul-item-test" style={{ width: '3.4rem', textAlign: 'center' }}>
              扫码联系我们
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <div> 版权所有：北京锐控自动化科技有限公司 </div>
          <div style={{ margin: '0 1rem ', display: 'flex', alignItems: 'center' }}>
            <img style={{ marginRight: '0.1rem' }} style={{ width: '.571429rem', height: '.571429rem' }} src={require('../../image/gongan.png')}></img>
            <span> 京公网安备11011202004028号</span>
          </div>
          <div> 2023备案号: 京ICP备2022029227号</div>
        </div>
      </div>
    )
  }
}
